import { render, staticRenderFns } from "./patch.vue?vue&type=template&id=24bf2378"
import script from "./patch.vue?vue&type=script&lang=js"
export * from "./patch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports